import { Box, Grid, MenuItem, Tooltip, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { Dispatch, SetStateAction, useContext } from "react";
import { Map } from "schemas/functions";

import DropdownSelect from "components/DropdownSelect";
import { ON_BEHALF_OF_TOKEN } from "utils/localStorage";
import { trackEvent } from "utils/tracking";
import { useSearchBrand } from "utils/useSearchBrand";

interface Props {
  label: string;
  options: {
    key: string;
    name: string;
    label?: string;
    paidOnly?: boolean;
    adminOnly?: boolean;
  }[];
  params: string;
  iconsMap?: Map;
  setClose: Dispatch<SetStateAction<boolean>>;
  close: boolean;
  isOptionSelected: (key: string, params: string) => boolean;
  isSmallScreen: boolean;
  selectedOptionIcon: JSX.Element;
}

const SelectFilter = ({
  label,
  options,
  params,
  iconsMap,
  setClose,
  close,
  isOptionSelected,
  isSmallScreen,
  selectedOptionIcon,
}: Props) => {
  const { addCategoryQueryToSearch } = useSearchBrand();
  const { subscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);

  const handleAddOption = (
    name: string,
    value: string,
    paidOnly: boolean = false,
  ) => {
    if (paidOnly && !subscription?.isSubscribed) {
      trackEvent("Restricted Filter Option Clicked", {
        "Filter Type": name,
        "Filter Name": value,
      });
      setUpgradeDialogSource("Restricted Filtering Feature");
      return;
    }
    addCategoryQueryToSearch(name, value);
    setClose(true);
  };

  const getIcon = (key: string, isLock: boolean) => {
    if (isLock) {
      return "🔒";
    }
    if (iconsMap && key in iconsMap) {
      return iconsMap[key];
    }
  };

  const isAdmin =
    Boolean(sessionStorage.getItem(ON_BEHALF_OF_TOKEN)) ||
    process.env.NODE_ENV === "development";

  const displayOptions = isAdmin
    ? options
    : options.filter((option) => !option.adminOnly);

  return (
    <DropdownSelect
      isSmallScreen={isSmallScreen}
      label={label}
      id={label}
      close={close}
      setClose={setClose}
    >
      {displayOptions.map((option) => (
        <MenuItem
          key={option.key}
          onClick={() => handleAddOption(params, option.key, option.paidOnly)}
        >
          <Tooltip title={option.label} placement="right">
            <>
              <Grid container alignItems="center">
                {isOptionSelected(option.key, params) && selectedOptionIcon}
                <Box sx={{ mr: 1 }}>
                  {getIcon(
                    option.key,
                    Boolean(option.paidOnly && !subscription?.isSubscribed),
                  )}
                </Box>
                <Typography>{option.name}</Typography>
              </Grid>
            </>
          </Tooltip>
        </MenuItem>
      ))}
    </DropdownSelect>
  );
};

export default SelectFilter;
